import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { OverviewConfig } from '@/lib/analytics/pages/overview';
import { OverviewGroupConfig } from '@/lib/analyticsGroup/pages/overview';
import { ANALYZE_OVERVIEW } from '@/lib/routes/privateRoutes';

import { LayoutAnalytics } from '@/components/layouts/wrappers/LayoutAnalytics';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';

const Overview = () => {
    const { t: tCommons } = useTranslation('commons');

    return (
        <WrapperSwitchLayout>
            <LayoutAnalytics
                profileConfig={OverviewConfig}
                groupConfig={OverviewGroupConfig}
                groupTitle="analytics:group_overview_title"
                title={tCommons('menu.overview')}
            />
        </WrapperSwitchLayout>
    );
};

export const getServerSideProps =
    TranslationService.getTranslationMessagesFromRoute(ANALYZE_OVERVIEW);

export default Overview;
